/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageView', ["CureItemToServiceUsageData", "CureItemToServiceUsage", "CureItemToServiceUsageSrv", "ReadOnlyBookingServiceView",
    function (CureItemToServiceUsageData, CureItemToServiceUsage, CureItemToServiceUsageSrv, ReadOnlyBookingServiceView) {

        var CureItemToServiceUsageView = function (cureItemToServiceUsage, ciIndex, cureItemToServiceView, domainView) {
            this.ciIndex = ciIndex; //model index
            this.domainView = domainView;
            this.cureItemToServiceView = cureItemToServiceView;
            this.hrView = null;
            this.usedQuantity = 0;
            this.usageTime = null;
            this.bookingServiceView = null;
            this.chronogicalIndex = null;
            this.useForm = {
                serviceView: cureItemToServiceView ? cureItemToServiceView.serviceView : null
            }
            if (cureItemToServiceUsage)
                this.loadDataFrom(cureItemToServiceUsage);

            this.chronogicalIndex = 0;
        };
        CureItemToServiceUsageView.prototype.getModel = function () {
            if (this.ciIndex != -1) {
                return CureItemToServiceUsageData.getByIndex(this.ciIndex);
            }
            return null;
        };
        CureItemToServiceUsageView.prototype.loadDataFrom = function (cureItemToServiceUsage) {
            if (cureItemToServiceUsage) {
                this.usedQuantity = cureItemToServiceUsage.usedQuantity;
                this.usageTime = cureItemToServiceUsage.usageTime;
                if (cureItemToServiceUsage.humanResource && this.domainView && this.domainView.getHrView !== undefined)
                    this.hrView = this.domainView.getHrView(cureItemToServiceUsage.humanResource);
                if (cureItemToServiceUsage.bookingService)
                    this.bookingServiceView = new ReadOnlyBookingServiceView(cureItemToServiceUsage.bookingService, -1, null);
            }
        };
        CureItemToServiceUsageView.prototype.reloadModel = function () {
            var cureItemToServiceUsage = this.getModel();
            if (cureItemToServiceUsage != null) {
                this.loadDataFrom(cureItemToServiceUsage);
            }
        };

        CureItemToServiceUsageView.prototype.copyDataTo = function (cureItemToServiceUsage) {
            if (cureItemToServiceUsage) {
                cureItemToServiceUsage.usedQuantity = this.usedQuantity;
                cureItemToServiceUsage.usageTime = this.usageTime;
                if (this.hrView)
                    cureItemToServiceUsage.humanResource = this.hrView.getModel();
                else
                    cureItemToServiceUsage.humanResource = null;
                if (this.bookingServiceView)
                    cureItemToServiceUsage.bookingService = this.bookingServiceView.getModel();
                else
                    cureItemToServiceUsage.bookingService = null;

                if (this.cureItemToServiceView) {
                    var newCureItemToService = this.cureItemToServiceView.getModel();
                    if (newCureItemToService)
                        if (cureItemToServiceUsage.cureItemToService)//already exist
                        {
                            if (newCureItemToService !== cureItemToServiceUsage.cureItemToService)//changed
                            {
                                cureItemToServiceUsage.cureItemToService.removeCureItemToServiceUsage(cureItemToServiceUsage);
                                newCureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);
                            }
                        } else
                            newCureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);

                }


            }
        };
        CureItemToServiceUsageView.prototype.duplicate = function (bsView) {
            if (this.cureItemToServiceView && bsView) {
                if (this.cureItemToServiceView.isUsed())
                    return null;
                var cureItemToServiceUsageView = new CureItemToServiceUsageView();
                cureItemToServiceUsageView.usedQuantity = this.usedQuantity;
                if (bsView.bookingView && bsView.bookingView.plgDayView && bsView.period)
                    cureItemToServiceUsageView.usageTime = new Date(bsView.bookingView.plgDayView.date.getTime() + bsView.period.start.getTime() * 60000);
                if (bsView.plgDayHrView)
                    cureItemToServiceUsageView.hrView = bsView.plgDayHrView.hrView;
                cureItemToServiceUsageView.bookingServiceView = bsView;
                bsView.price = 0;


                this.cureItemToServiceView.addCureItemToServiceUsageView(cureItemToServiceUsageView);
                return cureItemToServiceUsageView;
            }
            return null;
        };

        CureItemToServiceUsageView.prototype.initFromBookingServiceView = function (cureItemToServiceView, bsView) {
            if (bsView) {
                if (bsView.bookingView && bsView.bookingView.plgDayView && bsView.period)
                    this.usageTime = new Date(bsView.bookingView.plgDayView.date.getTime() + bsView.period.start.getTime() * 60000);
                this.cureItemToServiceView = cureItemToServiceView;
                this.bookingServiceView = bsView;
                if (bsView.plgDayHrView)
                    this.hrView = bsView.plgDayHrView.hrView;
                this.usedQuantity = 1;
                bsView.cureItemToServiceUsageView = this;

            }
        };

        CureItemToServiceUsageView.prototype.updateModel = function (saveUsage) {
            var cureItemToServiceUsage = this.getModel();
            if (cureItemToServiceUsage == null) {
                cureItemToServiceUsage = new CureItemToServiceUsage();
                this.ciIndex = CureItemToServiceUsageData.getIndexOf(cureItemToServiceUsage);
            }
            this.copyDataTo(cureItemToServiceUsage);
            if (saveUsage)
                CureItemToServiceUsageSrv.save(cureItemToServiceUsage);


        };
        CureItemToServiceUsageView.prototype.isChanged = function () {
            var cureItemToServiceUsage = this.getModel();
            if (cureItemToServiceUsage == null)
                return true;
            else {
                var humanResource = null;
                if (this.hrView)
                    humanResource = this.hrView.getModel();
                var bookingService = null;
                if (this.bookingServiceView)
                    bookingService = this.bookingServiceView.getModel();

                return (+cureItemToServiceUsage.usageTime !== +this.usageTime ||
                    cureItemToServiceUsage.usedQuantity != this.usedQuantity ||
                    cureItemToServiceUsage.humanResource !== humanResource ||
                    cureItemToServiceUsage.bookingService !== bookingService)
            }
        };
        CureItemToServiceUsageView.prototype.addUsageFromBookingServiceView = function (bsView) {
            if (bsView)
                this.usedQuantity++;
        };

        CureItemToServiceUsageView.prototype.removeModel = function () {

        };
        CureItemToServiceUsageView.prototype.onChangeServiceView = function () {
            if (this.cureItemToServiceView && this.useForm.serviceView !== this.cureItemToServiceView.serviceView) ;
            {
                this.cureItemToServiceView.removeCureItemToServiceUsageView(this);
                var newCureItemToServiceView = this.cureItemToServiceView.cureItemView.getFirstCureItemToServiceViewByServiceView(this.useForm.serviceView);
                if (newCureItemToServiceView)
                    newCureItemToServiceView.addCureItemToServiceUsageView(this);
            }
        };

        CureItemToServiceUsageView.prototype.initUseForm = function () {
            this.useForm.serviceView = this.cureItemToServiceView ? this.cureItemToServiceView.serviceView : null;
        };
        return CureItemToServiceUsageView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/CureItemToServiceUsageView.js